import ResourceTypes from 'legacy-packages/unit-outline/src/constants';
import { TeacherPracticeProblems } from 'chameleon/ui-stack/ui/units/subunit-content/spp';
import ShareWrapper from 'chameleon-packages/units/components/ShareWrapper';
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import ResourceAction from './ResourceAction';
import TopicQuestionCreateAction from './TopicQuestionCreateAction';
import PersonalProgressCheckAction from './PersonalProgressCheckAction';

const Container = ({
  type,
  resource,
  unitNumber,
  units,
  widgetTagColumn,
  unitsLabel,
  teacherAssignments,
  ppcCourseOutlineData,
  subunitLabel,
}) => {
  if (!resource) {
    return null;
  }

  if (type === ResourceTypes.SPP) {
    const unit = units.find(({ unitId }) => unitId === unitNumber);
    return (
      <TeacherPracticeProblems
        resources={[resource]}
        showRightContent={false}
        showResourceContent={false}
        unitTitle={unit.title}
        unitId={unitNumber}
        unitNumber={unitNumber}
        assignments={teacherAssignments}
      />
    );
  }

  if (type === ResourceTypes.EMBEDDED_VIDEO) {
    return <ResourceAction item={resource} unitNumber={unitNumber} />;
  }

  if (type === ResourceTypes.PRACTICE_QUESTIONS) {
    return (
      <TopicQuestionCreateAction
        item={resource}
        units={units}
        widgetTagColumn={widgetTagColumn}
        unitsLabel={unitsLabel}
        subunitLabel={subunitLabel}
      />
    );
  }

  if (type === ResourceTypes.ASSESSMENT) {
    return (
      <PersonalProgressCheckAction
        item={resource}
        teacherAssignments={teacherAssignments}
        unitNumber={unitNumber}
        courseOutlineData={ppcCourseOutlineData}
      />
    );
  }

  const shareWrapper = useMemo(() => {
    const { isShareable, id } = resource;
    if (isShareable) {
      return (
        <ShareWrapper
          key={`share-wrapper-${id}`}
          resource={{ ...resource, resourceId: id }}
          unitNumber={unitNumber}
        />
      );
    }
    return null;
  }, [resource.id, unitNumber]);

  if (
    type === ResourceTypes.URL ||
    type === ResourceTypes.SOURCE ||
    type === ResourceTypes.LTI
  ) {
    return shareWrapper;
  }

  return null;
};

Container.propTypes = {
  type: PropTypes.string.isRequired,
  resource: PropTypes.object.isRequired,
  unitNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  units: PropTypes.array.isRequired,
  widgetTagColumn: PropTypes.string,
  unitsLabel: PropTypes.string,
  teacherAssignments: PropTypes.array.isRequired,
  ppcCourseOutlineData: PropTypes.object,
  subunitLabel: PropTypes.string,
};

Container.defaultProps = {
  isPreApSubject: false,
  widgetTagColumn: null,
  unitsLabel: null,
  ppcCourseOutlineData: {},
  subunitLabel: null,
};

export default Container;
